import {
	ApplicationWrapper,
	RegisteredApplications,
	isEnvironment,
	useLocalStorage,
} from '@innovyze/stylovyze';
import { enableMapSet } from 'immer';
import React from 'react';

import './App.css';
import { globalization } from './i18n/globalization';
import useRoutes from './routes/useRoutes';
import './theme/innovyze-theme-devextreme.css';

enableMapSet();

function App() {
	const pages = useRoutes();

	const [isWeaveThemeEnabled] = useLocalStorage<boolean | undefined>(
		'weave-enabled',
		undefined,
	);

	const isNotProd =
		isEnvironment('DEV') || isEnvironment('QA') || isEnvironment('LOCAL');
	return (
		<ApplicationWrapper
			helpModals={isNotProd}
			applicationContext={{
				applicationName: RegisteredApplications.APP_ADMIN,
			}}
			pages={pages}
			globalization={globalization}
			injectTenantId
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			disableMapProvider={true}
			hasWeaveTheme={!!isWeaveThemeEnabled}
		/>
	);
}

export default App;
